import './AdminTopBar.css';

export default function AdminTopBar({ title, subtitle, session }) {
  const email = session?.user?.email || 'Admin';
  const initials = email.charAt(0).toUpperCase();

  return (
    <div className="admin-topbar">
      <div className="topbar-titles">
        <h1 className="topbar-title">{title}</h1>
        {subtitle && <p className="topbar-subtitle">{subtitle}</p>}
      </div>
      <div className="topbar-right">
        <div className="topbar-admin">
          <div className="topbar-avatar">{initials}</div>
          <span className="topbar-admin-label">Admin</span>
        </div>
      </div>
    </div>
  );
}
